module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-zadni-cela.50db59be.jpg";